import { Button, Col, Image, Modal, Row, Typography } from "antd";
import { useState } from "react";

import { strings } from "@utils/Strings";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { supportEmail } from "~/Utils";
import styles from "./LandingPage.module.scss";

import UnderPreview from "@assets/SVG/underReview.svg";
import WelcomePage from "@assets/SVG/welcome-page.svg";

export const LandingPage = () => {
  const navigate = useNavigate();
  const user: any = JSON.parse(localStorage.getItem("user") ?? "{}");
  const [modalOpen, setModalOpen] = useState(user?.status == "pending");

  return (
    <ContentWrapper>
      <Row>
        <Col span={24}>
          <Typography.Title
            className={styles.TextCenter}
            level={3}
          >
            Welcome to Enterprise Content Management System (ECMS)
          </Typography.Title>
        </Col>
      </Row>
      <Row
        className={styles.TextPadding}
        gutter={[24, 24]}
        style={{ marginTop: styles.whitespace5 }}
      >
        <Col
          lg={12}
          md={24}
          sm={24}
        >
          <Image
            src={WelcomePage}
            preview={false}
          />
        </Col>
        <Col
          lg={12}
          md={24}
          sm={24}
        >
          <Typography.Title level={4}>Access Denied: No Role Assigned</Typography.Title>
          <Typography.Text>
            It appears that your account does not have any roles assigned at this time. This means you currently do not
            have the necessary permissions to access certain features or sections of the application.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text>
            To resolve this issue, please contact the system administrator. They will be able to assign the appropriate
            roles to your account, ensuring you have the access you need.
          </Typography.Text>
          <br />
          <br />
          {/* <Button type="primary">Logout</Button> */}
        </Col>
      </Row>
      <Row style={{ paddingTop: styles.whitespace7 }}>
        <Col span={24}>
          <Typography.Title
            className={styles.TextCenter}
            level={4}
          >
            Contact Support
          </Typography.Title>
        </Col>
        <Col
          className={styles.TextCenter}
          span={24}
        >
          <Typography.Text className={styles.TextCenter}>
            For any questions or assistance, please reach out to our support team at
          </Typography.Text>
        </Col>
        <Col
          className={styles.TextCenter}
          span={24}
        >
          <Typography.Title
            style={{ color: styles.secondaryBlue }}
            level={5}
            className={styles.TextCenter}
          >
            {supportEmail}
          </Typography.Title>
        </Col>
      </Row>
      <Modal
        open={modalOpen}
        maskClosable={false}
        centered
        onCancel={() => {
          setModalOpen(false);
        }}
        closable={true}
        footer={null}
        width={800}
      >
        <Row
          style={{ marginTop: 20 }}
          justify="center"
        >
          <Col>
            <Image
              src={UnderPreview}
              preview={false}
            />
          </Col>
        </Row>
        <Row
          style={{ marginTop: 10 }}
          justify="center"
        >
          <Col>
            <Typography.Title
              style={{ color: styles.strawberry }}
              level={3}
            >
              {"Under Review"}
            </Typography.Title>
          </Col>
        </Row>
        <Row
          justify="center"
          style={{ marginTop: 30 }}
        >
          <Col style={{ textAlign: "center" }}>
            <Typography.Text style={{ paddingBottom: 5 }}>{strings.underReview}</Typography.Text>
          </Col>
        </Row>
        <Row
          justify="center"
          style={{ marginTop: 20 }}
        >
          <Col>
            <Button
              style={{ width: 100 }}
              type="primary"
              onClick={() => {
                setModalOpen(false);
                navigate("/clm/welcome-page");
              }}
            >
              Okay
            </Button>
          </Col>
        </Row>
        <Row style={{ paddingTop: styles.whitespace7 }}>
          <Col span={24}>
            <Typography.Title
              className={styles.TextCenter}
              level={4}
            >
              Need Assistance?
            </Typography.Title>
          </Col>
          <Col
            className={styles.TextCenter}
            span={24}
          >
            <Typography.Text className={styles.TextCenter}>
              For any questions or assistance, please reach out to our support team at
            </Typography.Text>
          </Col>
          <Col
            className={styles.TextCenter}
            span={24}
          >
            <Typography.Title
              style={{ color: styles.secondaryBlue }}
              level={5}
              className={styles.TextCenter}
            >
              {supportEmail}
            </Typography.Title>
          </Col>
        </Row>
      </Modal>
    </ContentWrapper>
  );
};
